export const IS_SERVER			:boolean = false;
export const DATA_VERSION		:string = "1.0.0";